
<template>
  <div class="analytics-page">
    <div class="chart-container">
      <div id="chart">
        <div class="flex justify-between items-center">
          <h2 class="font-bold">{{ header }}</h2>
          <p>...</p>
        </div>
        <apexchart
          ref="chart"
          type="donut"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    keys: Number,
    showLabels: Boolean,
    showTotal: String,
    totalLabel: Array,
    header: String,
    series: Array,
    labels: Array,
    colors: Array,
    fontSize: String
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'donut',
          height: 350
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: this.showLabels,
                total: {
                  show: true,
                  label: this.totalLabel?.[0] || 'No data',
                  formatter: (w) => {
                    return this.keys === 0
                      ? w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                      : '';
                  }
                }
              }
            }
          }
        },
        dataLabels: { enabled: false },
        labels: this.labels,
        colors: this.colors,
        legend: {
          position: 'bottom',
          fontSize: this.fontSize
        }
      };
    }
  },

  watch: {
    labels: {
      deep: true,
      handler(newLabels) {
        this.$refs.chart?.updateOptions({ labels: newLabels });
      }
    },
    colors: {
      deep: true,
      handler(newColors) {
        this.$refs.chart?.updateOptions({ colors: newColors });
      }
    },
    series: {
      deep: true,
      handler(newSeries) {
        this.$refs.chart?.updateSeries(newSeries);
      }
    }
  }
};
</script>


<style scoped>
.chart-container {
  padding: 30px;
}

</style>